import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

export const valuesHasNotChanged = (initialState, currentState) =>
  isEqual(initialState, currentState);

export const isInitialStateEmpty = ({ includeBilling, ...initialState }) =>
  Object.values(initialState).every(value => isEmpty(value));

export const shouldDisableSave = (initialState, currentState) =>
  valuesHasNotChanged(initialState, currentState) || isInitialStateEmpty(initialState);
